import React from 'react';

import * as Sentry from '@sentry/react';
import PropTypes from 'prop-types';
import { Route } from 'react-router-dom';

const SentryRoute = Sentry.withSentryRouting(Route);

const RouteWithSubRoutes = (props) => {
    const {
        component: Component,
        path,
        routes,
    } = props;

    function renderFunction(props) {
        return <Component {...props} routes={routes} />;
    }

    return (
        <SentryRoute
            path={path}
             
            render={renderFunction}
        />
    );
};

RouteWithSubRoutes.propTypes = {
    component: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
    path: PropTypes.string,
    routes: PropTypes.arrayOf(PropTypes.shape({
        path: PropTypes.string,
        exact: PropTypes.bool,
        component: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
    })),
};

export default RouteWithSubRoutes;
